// extracted by mini-css-extract-plugin
export default {"topBottomOverflowFade":"readstyle_topBottomOverflowFade__NAC+H"};